import {
  formatMoneyComma,
  handleTotalMoney,
  handleTotalMoneyComma,
  handleFieldsOnKeyup,
  handleInputsDate,
  transformSpanIntoInput,
  setInfinityOnChange,
  setLoader,
  disableLoader,
} from "../tabs";

export function updateFieldsAjax(field) {
  let parent = field.closest(".nested-fields");
  let fields = parent.find(".o-js-field");

  let query = {
    fund_id: parent.find(".o-js-fund_id").val(),
    fund_name: parent.find(".o-js-fund_name").text(),
    investment_value: parseFloat(parent.find(".o-js-investment_value").text()),
  };

  query["estate_type_change"] = field.hasClass("o-js-estate_type")
    ? true
    : false;
  query["estate_percent_change"] = field.hasClass("o-js-estate_percent")
    ? true
    : false;
  query["duration_change"] = field.hasClass("o-js-duration") ? true : false;
  query["share_value_change"] = field.hasClass("o-js-share_value")
    ? true
    : false;
  query["purchase_date_change"] = field.hasClass("o-js-date-input")
    ? true
    : false;

  fields.each(function (key, input) {
    if ($(input).data("default") != $(input).val()) {
      if ($(input).is("select")) {
        query[$(input).data("type")] = $(input).val();
      } else {
        query[$(input).data("type")] = $(input).val();
      }
    }
  });

  $.ajax({
    url: "/investment_funds/calculate.json?" + $.param(query),
    type: "GET",
    success: function (response) {
      result = response.data.result;
      $.each(result, function (key, valueObj) {
        fields.each(function () {
          if (key == $(this).data("type")) {
            if ($(this).is("p")) {
              $(this).text(valueObj);
            } else {
              $(this).val(valueObj);
            }
          }
        });
      });
      $(".o-js-total-table thead th").each(function (i) {
        if ($(this).hasClass("is-summable")) {
          calculateColumn($(this).index());
        }
      });
      getShareAndFaiValues();
      sumShareValue();
    },
    beforeSend: function () {
      setLoader(field);
    },
    complete: function () {
      disableLoader(field);
      handleFieldsOnKeyup();
      transformSpanIntoInput();
      setInfinityOnChange();
      handleInputsDate();
    },
  });
}

export function resetFieldsAjax() {
  let btn = $(".o-js-reset");

  btn.on("click", function (e) {
    let parent = $(this).closest(".nested-fields");
    let fields = parent.find(".o-js-field");

    let query = {
      fund_id: parent.find(".o-js-fund_id").val(),
    };
    e.preventDefault();
    $.ajax({
      url: "/investment_funds/calculate.json?" + $.param(query),
      type: "GET",
      success: function (response) {
        result = response.data.result;
        $.each(result, function (key, valueObj) {
          fields.each(function () {
            if (key == $(this).data("type")) {
              if ($(this).is("p")) {
                $(this).text(valueObj);
              } else {
                $(this).val(valueObj);
              }
            }
          });
        });
        handleFieldsOnKeyup();
        transformSpanIntoInput();
        handleInputsDate();
        $(".o-js-total-table thead th").each(function (i) {
          if ($(this).hasClass("is-summable")) {
            calculateColumn($(this).index());
          }
        });
        setInfinityOnChange();
      },
    });
  });
}

export function handleTotalLine(table) {
  let total = table.find(".is-total");
  total.hide();

  let lines = table.find("tbody tr:visible");
  if (lines.length >= 2) {
    total.show();
  } else {
    total.hide();
  }
}

export function calculateColumn(index) {
  var total = 0;
  $("table tbody tr:visible:not(.is-total)").each(function () {
    var tds = $(this).find("td");
    tds.each(function (i) {
      if ($(this).index() == index) {
        var value = parseFloat($("input", this).val());
        if (!isNaN(value)) {
          total += value;
        }
      }
    });
  });
  $("table tr.is-total td").each(function (element, i) {
    if ($(this).data("motto") == "€," && $(this).index() == index) {
      $(this).text(formatMoneyComma(parseFloat(total)));
    } else if ($(this).data("motto") == "" && $(this).index() == index) {
      $("table tr.is-total td").eq(index).text(total);
    }
  });
  handleTotalMoney();
}

export function getShareAndFaiValues() {
  const completeTable = [];
  $(".o-wallet-table tbody tr:not(.is-total)").each(function () {
    var tableLine = [];
    var share = $(this).find(".o-js-share_value");
    var fai = $(this).find(".o-js-amount_with_fee");
    var shareValue = parseFloat(share.val());
    var faiValue = parseFloat(fai.val());
    tableLine.push(shareValue, faiValue);
    completeTable.push(tableLine);
  });
  return completeTable;
}

export function sumShareValue() {
  var completeTable = getShareAndFaiValues();
  var totalResult = $(".o-js-share_value-result");
  $.ajax({
    url:
      "/investment_funds/share_value_total.json?values=" +
      JSON.stringify(completeTable),
    type: "GET",
    success: function (response) {
      result = response.data.total;
      totalResult.text(result);
      handleTotalMoney();
      handleTotalMoneyComma();
    },
  });
}

export function handleAddFieldsButton(user) {
  let addFieldsButton = $(".add_fields");

  if (user) {
    if (user.current_user) {
      if (!user.can_create_multiple_investment_funds) {
        if ($(document).find(".nested-fields ").length == 1) {
          if (user.can_create_less_than_two_investment_funds) {
            addFieldsButton
              .attr("data-remote", true)
              .attr("href", "/portefeuilles/no_access");
          }
        } else if ($(document).find(".nested-fields ").length == 2) {
          if (!user.can_create_more_than_two_investment_funds) {
            addFieldsButton
              .attr("data-remote", true)
              .attr("href", "/portefeuilles/no_access");
          }
        } else if ($(document).find(".nested-fields ").length == 3) {
          if (!user.can_create_more_than_five_investment_funds) {
            addFieldsButton
              .attr("data-remote", true)
              .attr("href", "/portefeuilles/no_access");
          }
        }
      }
    } else {
      if ($(document).find(".nested-fields ").length == 1) {
        addFieldsButton
          .attr("data-remote", true)
          .attr("href", "/portefeuilles/no_access");
      }
    }
  } else {
    addFieldsButton.attr("data-remote", false).attr("href", "#");
  }
}

export function handleSubmitButton() {
  let submitButton = $(".o-js-investment_funds_submit");

  if ($(document).find(".nested-fields ").length > 0) {
    submitButton.removeClass("disabled").attr("disabled", false);
  } else {
    submitButton.addClass("disabled").attr("disabled", true);
  }
}
